// Tiny browser-only event bus for the Seedance source-clip boundary.
//
// The source slot and the pieces of state it owns live in sibling components
// (prompt, Omni refs, Asset Library refs). Passing another four callbacks
// through SeedanceVFXTool would make the 3k-line parent an even larger state
// switchboard. One explicit event keeps the boundary observable and testable.
import axios from "axios";
import { installGenerationSessionTelemetry } from "./generationSessionTelemetry";

export const SHOT_SCOPE_EVENT = "orca:seedance-shot-scope";

let currentShotScope = "workspace";

export function getCurrentShotScope() {
  return currentShotScope;
}

export function emitShotScopeChange(detail) {
  const d = detail || {};
  currentShotScope = d.nextScope || "workspace";
  if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") return;
  window.dispatchEvent(new CustomEvent(SHOT_SCOPE_EVENT, { detail: d }));
}

export function subscribeShotScopeChange(listener) {
  if (typeof window === "undefined" || typeof window.addEventListener !== "function") {
    return () => {};
  }
  const handler = (event) => listener(event?.detail || {});
  window.addEventListener(SHOT_SCOPE_EVENT, handler);
  return () => window.removeEventListener(SHOT_SCOPE_EVENT, handler);
}

// Install once when any Seedance surface imports the bus. The telemetry lives
// in Job.client_context only and never changes the ARK request body.
installGenerationSessionTelemetry(axios, getCurrentShotScope);
